// extracted by mini-css-extract-plugin
export var footer = "_l9-5";
export var fulfillmentInput = "_l9-0";
export var shipDateInput = "_l9-1";
export var shipmentModal = "_l9-2";
export var shipmentModalContent = "_l9-3";
export var tableContainer = "_l9-4";